'use client';

import { routes } from '@routes';
import {
  MobileSearchModal,
  MobileSearchModalProvider,
} from '@components/mobile-search-modal';
import { MobileSearchBar } from '@components/mobile-search-bar';

interface MobileHeroSearchProps {
  placeId?: string;
  placeName: string;
}

/**
 * Client component for mobile search functionality.
 * Required because onSubmit handlers cannot be passed across
 * the server/client component boundary.
 */
export function MobileHeroSearch({
  placeId,
  placeName,
}: MobileHeroSearchProps) {
  return (
    <MobileSearchModalProvider>
      <MobileSearchModal
        onSubmit={(vals) => {
          window.location.assign(
            routes.searchShow({
              placeId: vals.placeId,
              checkInDate: vals.checkInDate || undefined,
              checkOutDate: vals.checkOutDate || undefined,
              adultCount: vals.adultCount,
              childCount: vals.childCount,
              infantCount: vals.infantCount,
              petCount: vals.petCount,
            })
          );
        }}
        placeId={placeId}
        placeName={placeName}
      />
      {/* Override MobileSearchBar's sm:hidden since we show overlay up to lg */}
      <div className="[&>div]:!block">
        <MobileSearchBar placeName={placeName || 'Search destinations'} />
      </div>
    </MobileSearchModalProvider>
  );
}
